import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { StoragePlacesState } from './types';

export default function initialState(): StoragePlacesState {
  return { ...initialStateSubscribable() };
}
